module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "pxiii"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "acknowledgements",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Text/toc#toc-illustration"
    }
  }, [_vm._v("List of Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche, aged 13, at the time of his confirmation ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Karl Ludwig Nietzsche (Nietzsche’s father) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vicarage at Röcken ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Franziska Nietzsche (Nietzsche’s mother) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elisabeth Nietzsche (Nietzsche’s sister) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilhelm Pinder ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rudelsburg Castle ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Naumburg’s Marktplatz (Markt) ("), _c('em', [_vm._v("photo of lithograph")]), _vm._v(" courtesy of Naumburg Stadtmuseum)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carl von Gersdorff ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche, as student graduating from Pforta ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche holding sabre, striking military pose ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three friends in Leipzig – Nietzsche, Gersdorff, Rohde ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche as student at Leipzig ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Arthur Schopenhauer ("), _c('em', [_vm._v("photo")]), _vm._v(" Roger-Viollet, Paris)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friedrich Ritschl, Nietzsche’s favourite Professor of Philology ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche, with members of his Leipzig Philological Club ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cosima Wagner, drawing by Franz von Lenbach ("), _c('em', [_vm._v("photo")]), _vm._v(" Roger-Viollet, Paris)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("View from Wagner’s house at Tribschen ("), _c('em', [_vm._v("photo")]), _vm._v(" Georg Anderhub, Lucerne)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Richard Wagner ("), _c('em', [_vm._v("photo")]), _vm._v(" Roger-Viollet, Paris)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("View of Wagner’s house at Tribschen ("), _c('em', [_vm._v("photo")]), _vm._v(" courtesy of Wagner Museum, Lucerne)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malwida von Meysenbug ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heinrich Köselitz (alias ‘Peter Gast’) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Franz Overbeck (Professor of Theology) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ida Overbeck (his wife) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Franziska Nietzsche’s corner house on Weingartenstrasse in Naumburg ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lou Salomé ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _c('a', {
    attrs: {
      "id": "pxiv"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Friedrich Nietzsche in 1882 ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul Rée (photo taken by Ferreti in Naples) ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elisabeth Nietzsche ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photograph taken in Lucerne in August 1882 of Lou Salomé (holding whip and ‘reins’), Paul Rée, F. Nietzsche (as two ‘workhorses’) (GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche’s bedroom in grocer-mayor’s house at Sils-Maria ("), _c('em', [_vm._v("photo")]), _vm._v(" Max Weiss, Montabella Verlag, St. Moritz)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sils Baseglia (village with steeple, next to Sils-Maria) ("), _c('em', [_vm._v("photo")]), _vm._v(" courtesy of Verkehrsverein Sils-Engadin)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("View of Sils Lake, looking Southwest ("), _c('em', [_vm._v("photo")]), _vm._v(" Max Weiss, Montabella Verlag, St. Moritz)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche with his mother in May 1892, after his mental collapse ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche in 1899, etching by Hans Olde ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nietzsche’s sister Elisabeth Förster-Nietzsche in late middle-aged widowhood ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])]), _vm._v(" "), _c('p', {
    staticClass: "indenthanging"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/chapter026#a037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chancellor Adolf Hitler visiting Elisabeth Förster -Nietzsche in Weimar, 1934 ("), _c('em', [_vm._v("photo")]), _vm._v(" GSA Stiftung Weimarer Klassik)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39344b66","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/illustration.vue
// module id = 72
// module chunks = 0